module.exports = __webpack_public_path__ + "static/media/next-button.74069835.svg";